import * as Yup from "yup";
import httpClient from "../config/HttpClient";
import EntityId from "../EntityId";
import { translations } from "../../../translations/common";

const RULES_URL = "/access/rules";

export interface AccessRuleForm {
  userId: string;
  ipAddresses: string[];
  browserIds: string[];
  enabled: boolean;
}

export interface AccessRuleView extends AccessRuleForm {
  id?: string;
}

export const defaultAccessRuleForm: Readonly<AccessRuleForm> = {
  userId: "",
  ipAddresses: [],
  browserIds: [],
  enabled: false,
};

export const accessRuleSchema = Yup.object().shape({
  userId: Yup.string().required(translations.accessRules.form.validation.userIdRequired),
  ipAddresses: Yup.array().of(Yup.string()),
  browserIds: Yup.array().of(Yup.string()),
  enabled: Yup.boolean().required(),
});

export class AccessRuleModel {
  static async updateOrCreate(model: AccessRuleView | (AccessRuleForm & { id?: string })): Promise<EntityId> {
    const url = model.id ? `${RULES_URL}/${model.id}` : RULES_URL;
    const method = model.id ? httpClient.put : httpClient.post;

    // If updating, remove userId from the payload
    const payload = model.id
      ? { ...model, userId: undefined }
      : model;

    const response = await method<EntityId>(url, payload);
    return response.data;
  }

  static async listAll(): Promise<AccessRuleView[]> {
    const response = await httpClient.get<AccessRuleView[]>(RULES_URL);
    return response.data;
  }

  static async findOne(id: string): Promise<AccessRuleView> {
    const response = await httpClient.get<AccessRuleView>(`${RULES_URL}/${id}`);
    return response.data;
  }

  static async delete(id: string): Promise<void> {
    await httpClient.delete(`${RULES_URL}/${id}`);
  }
}

export default AccessRuleModel;
